import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';
import toast from 'react-hot-toast';
import { ChevronLeft, User, Lock, ShieldCheck } from 'lucide-react';

export default function ProfilePage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [passForm, setPassForm] = useState({ oldPassword: '', newPassword: '', confirmPassword: '' });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    document.title = "Profil - Penjadwalan Acara Pimpinan";
  });

  const handleChangePass = async (e) => {
    e.preventDefault();
    if (passForm.newPassword !== passForm.confirmPassword) {
      toast.error('Konfirmasi password tidak cocok');
      return;
    }
    setSaving(true);
    try {
      await api.put('/auth/change-password', {
        oldPassword: passForm.oldPassword,
        newPassword: passForm.newPassword,
      });
      toast.success('Password berhasil diubah');
      setPassForm({ oldPassword: '', newPassword: '', confirmPassword: '' });
    } catch (err) {
      toast.error(err.response?.data?.message || 'Gagal mengubah password');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="page-container" style={{ maxWidth: 640 }}>
      <button className="btn btn-ghost btn-sm" style={{ marginBottom: 20 }} onClick={() => navigate(-1)}>
        <ChevronLeft size={16} /> Kembali
      </button>

      {/* Profile card */}
      <div className="card" style={{ marginBottom: 20 }}>
        <div className="card-body">
          <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
            <div style={{
              width: 72, height: 72, borderRadius: 20,
              background: 'linear-gradient(135deg, var(--primary), var(--primary-light))',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: 'white', fontSize: 28, fontWeight: 800,
            }}>
              {user?.nama?.[0]?.toUpperCase()}
            </div>
            <div>
              <h2 style={{ fontSize: 22, fontWeight: 800 }}>{user?.nama}</h2>
              <p style={{ color: 'var(--gray-400)', fontSize: 14 }}>{user?.email}</p>
              <div style={{ marginTop: 8, display: 'flex', gap: 8 }}>
                <span className={`badge ${user?.role === 'admin' ? 'badge-orange' : 'badge-blue'}`}>
                  {user?.role === 'admin' ? <><ShieldCheck size={11} /> Administrator</> : <><User size={11} /> Staff</>}
                </span>
              </div>
            </div>
          </div>

          <div style={{ marginTop: 24, padding: 16, background: 'var(--gray-50)', borderRadius: 10 }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              {[
                { label: 'Username', value: user?.username },
                { label: 'Email', value: user?.email },
                { label: 'Role', value: user?.role === 'admin' ? 'Administrator' : 'Staff' },
              ].map(item => (
                <div key={item.label}>
                  <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--gray-400)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{item.label}</div>
                  <div style={{ fontSize: 14, fontWeight: 600, marginTop: 2 }}>{item.value}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Change password */}
      <div className="card">
        <div className="card-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <Lock size={18} color="var(--gray-600)" />
            <span style={{ fontWeight: 700 }}>Ubah Password</span>
          </div>
        </div>
        <div className="card-body">
          <form onSubmit={handleChangePass} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div className="form-group">
              <label className="form-label">Password Lama</label>
              <input
                className="form-input" type="password"
                value={passForm.oldPassword}
                onChange={e => setPassForm(f => ({ ...f, oldPassword: e.target.value }))}
                required placeholder="Masukkan password lama"
              />
            </div>
            <div className="form-group">
              <label className="form-label">Password Baru</label>
              <input
                className="form-input" type="password"
                value={passForm.newPassword}
                onChange={e => setPassForm(f => ({ ...f, newPassword: e.target.value }))}
                required minLength={6} placeholder="Minimal 6 karakter"
              />
            </div>
            <div className="form-group">
              <label className="form-label">Konfirmasi Password Baru</label>
              <input
                className="form-input" type="password"
                value={passForm.confirmPassword}
                onChange={e => setPassForm(f => ({ ...f, confirmPassword: e.target.value }))}
                required placeholder="Ulangi password baru"
              />
            </div>
            <button type="submit" className="btn btn-primary" disabled={saving} style={{ alignSelf: 'flex-start' }}>
              {saving ? <span className="loader" /> : <Lock size={16} />}
              {saving ? 'Menyimpan...' : 'Ubah Password'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
